module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA4ElEQVQ4T62S0bEBURBET3/7IAQZIAIbghBk8F4GiAARIAQZ8OFfCO9FQAat5tauum5hq5Sp2o+9Mz09PdPiw5DtITABtpL+2vrYngPnBJR0zgF1cly/HYC1pGtTkzC2+zmT7V9gWTAvJAVTioSxXUmKrs1jFMwK4FFSldVUXwVOgU3LqE8Ze8ClAI7yBSZ5pcZafM66kxT/93gH3AInoAN0JS2eAdM5bIcJfoD79opxY/N7SauHc9gObZEcvHDPfzgstDaj9oFgTbe0HXriCyt2gWPdcBXuCRBwVZs3X+VvvyOVm55DOPYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./styles/icons/rlsb.png
// module id = 2917
// module chunks = 0